<!--下载插件-->
<template>
  <div class="help_info_home">
    <div class="help_content">
      <div class="l_box">
        <div class="top_title">{{ data.title }}</div>
        <div class="content-box" v-html="data.text">{{ data.text }}</div>
        <div class="footer-box">
          <div class="read_num">阅读 {{ data.see }}</div>
          <div class="control-box">
            <div
              class="item"
              v-if="up_title"
              @click="onItemClick(null, 'true')"
            >
              <Icon type="md-arrow-back" size="20" />
              <div style="text-align: right">
                <div class="up">上一篇</div>
                <div>{{ up_title }}</div>
              </div>
            </div>
            <div
              class="item"
              v-if="down_title"
              @click="onItemClick(null, 'false')"
            >
              <div>
                <div class="up">下一篇</div>
                <div>{{ down_title }}</div>
              </div>
              <Icon type="md-arrow-forward" size="20" />
            </div>
          </div>
          <div class="bottom-box">
            <div>
              <img class="logo" src="../../../assets/images/logo03.png" />
              <span class="date"
                >最近更新：{{ $moment(data.create_time) }}</span
              >
            </div>
            <div class="rt">
              <Icon
                type="md-thumbs-up"
                size="23"
                class="like"
                :class="{ like_active: isUse == 1 }"
                :color="isUse == 1 ? '#487AF7' : ''"
                @click="setUse(1)"
              />
              <span>有用</span>

              <Icon
                type="md-thumbs-down"
                size="23"
                class="like"
                :class="{ like_active: isUse == 0 }"
                :color="isUse == 0 ? '#487AF7' : ''"
                @click="setUse(0)"
              />
              <span>没用</span>
            </div>
          </div>
        </div>
      </div>
      <div class="r_box">
        <div class="list-box">
          <div
            class="list-item"
            :class="{ active: id == item.id }"
            v-for="(item, index) in List"
            :key="index"
            @click="onItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  inject: ["reload"],
  data() {
    return {
      data: {},
      info: '<div>123</div><input placeholder="从文档中搜寻答案"/>',
      List: [],
      up_title: null,
      up_id: null,
      down_title: null,
      down_id: null,
      isUse: "-1",
      id: "",
      catId: "",
      scrollHeight: 900,
    };
  },
  created() {
    window.addEventListener("resize", this.getHeight());
  },
  mounted() {
    this.id = this.$route.query.id;
    this.catId = this.$route.query.catId;
    this.getData();
    this.getList();
  },
  methods: {
    ...mapActions(["GetDocsDetails", "ThumbsDocs", "GetDocs"]),
    getHeight() {
      this.scrollHeight = window.innerHeight - 100;
      console.log("屏幕高度", window.innerHeight);
    },
    getData() {
      this.GetDocsDetails({ id: this.id }).then((res) => {
        this.data = res.data;
      });
    },
    getList() {
      this.GetDocs({ id: this.catId, status: 0 }).then((res) => {
        this.List = res.data;
        console.log("数据", res.data);
        let current = 0;
        this.List.map((item, index) => {
          if (item.id == this.id) {
            current = index;
          }
        });
        if (current) {
          this.up_title = this.List[current - 1].title;
          this.up_id = this.List[current - 1].id;
          if (current < this.List.length - 1) {
            this.down_title = this.List[current + 1].title;
            this.down_id = this.List[current + 1].id;
          }
        } else {
          this.down_title = this.List[current + 1].title;
          this.down_id = this.List[current + 1].id;
        }
      });
    },
    setUse(use) {
      this.isUse = use;
      this.ThumbsDocs({ id: this.id, type: use ? "useful" : "useless" }).then(
        (res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
        }
      );
    },

    onItemClick(item, isUp) {
      if (isUp) {
        console.log("id", this.up_id, this.down_id);
        this.$router.push({
          path: "/help/info",
          query: {
            id: isUp == "true" ? this.up_id : this.down_id,
            catId: this.catId,
          },
        });
      } else {
        this.$router.push({
          path: "/help/info",
          query: { id: item.id, catId: this.catId },
        });
      }
      setTimeout(() => {
        this.reload();
      }, 500);
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
